import { useState, useCallback } from 'react';
import { useStableFn } from '../../../../hooks/useStableFn';

export const useCreateRowProps = ({ colCount, expandedRowRender }) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const expandedRowRenderFn = useStableFn(expandedRowRender);

  const handleRowClick = useCallback((rowId) => {
    setExpandedRowKeys((prev) =>
      prev.includes(rowId)
        ? prev.filter((key) => key !== rowId)
        : [...prev, rowId]
    );
  }, []);

  const handleRow = useCallback(
    (record) => {
      return {
        onClick: () => handleRowClick(record.alertId),
        record,
        colCount,
        expanded: expandedRowKeys.includes(record.alertId),
        expandedRowRender:
          typeof expandedRowRenderFn === 'function'
            ? expandedRowRenderFn
            : null,
      };
    },
    [handleRowClick, colCount, expandedRowKeys]
  );

  return {
    expandedRowKeys,
    handleRow,
  };
};
